// @ts-nocheck
import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { IoSettingsOutline } from "react-icons/io5";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState } from "recoil";
import { AtomFormState } from "../../../../atoms/FormAtom";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_FTL_CONSIGNMENT_NOTE,
  Delete_FTL_LR,
  EditFTLLoadReceipt,
  getFormSectionsAndFields,
  GetFTLLoadReceiptById,
  GetFTLLoadReceiptByIdForCopy,
  GrtPreferenceByFormKey,
  LOCK_FTL_CONSIGNMENT_NOTE,
  UserDataById
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import Button from "../../Button/Button";
import { Confirm } from "../../Confirmation/Confirm";
import { FormConfiguration } from "../../FormConfiguration/FormConfiguration";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import {
  ClearFields,
  getDaysDifference,
  handleFormReset,
  updateSingleField,
  updateValueForm,
} from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import AddInvoiceAndItemModal from "../AddConsignmentNote/AddInvoiceAndItemModal/AddInvoiceAndItemModal";
import InvoiceAndItemTable from "../AddConsignmentNote/InvoiceAndItemTable/InvoiceAndItemTable";
import MainUserDetails from "../AddConsignmentNote/ReusableComponent/MainUserDetails";
import LRPickupUpdationFreightChargesForm from "../LRPickupUpdation/LRPickupUpdationSections/LRPickupUpdationFreightChargesForm";
import "./AddFTLConsignmentNote.scss";
import {
  AddMaterial,
  AddMeterialDocsUpload,
  AddMeterialItems,
  FTLConsignmentNoteConfiguration,
  Loadfilds
} from "./AddFTLConsignmentNoteConfig";

const AddFTLConsignmentNote = ({ fielddata, show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, " FTL Consignment Note");
  const Form_Key = "FTL_Consignment_Note";
  const [LoadFieldsstate, setLoadFields] = useState<any>(Loadfilds);
  const [FormData, setFormdata] = useState<any>({});
  const [toggle, settoggle] = useState(show ? show : false);
  const [notesdata, setNotesdata] = useState("");
  const [myData, setMyData] = useState<any>({ material: [] });
  const [autoLRNo, setAutoLRNo] = useState(false);
  const [totalQuantity, setTotalQuantity] = useState(0);
  // const [sendValue, setSendValue] = useState(0);
  const [invoiceData, setInvoiceData] = useState([]);
  const [itemsData, setItemsData] = useState([]);
  const [modifiedItemData, setModifiedItemData] = useState([]);
  const [allFieldsData, setAllFieldsData] = useState({});
  const [totalFreightAmount, setTotalFreightAmount] = useState(0);
  const { pushModal, popModal, getTopModal } = useModalContext();
  const [customerNotesdata, setCustomerNotesdata] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [Meterial, setMeterial] = useState(false);
  const [editIndex, setEditIndex] = useState("");
  const [FormValue, setFormValue] = useRecoilState(AtomFormState(Form_Key));
  const [perKM, setperKM] = useState(0);
  const [currentBranch, setCurrentBranch] = useState("");
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [openSetting, setOpenSetting] = useState(false);
  const [LRcenterDisabled, setLRCenterDisabled] = useState(false);
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer.FTL_Consignment_Note);
  const selectedRow = fielddataRedux?.Selected_Row?._id;
  let userData = sessionStorage.getItem("userData") && JSON.parse(sessionStorage?.getItem("userData") || "");
  const dispatch = useDispatch();
  const formRef = useRef({});
  const BranchRef = useRef(null);
  const [formErrors, setFormErrors] = useState<any>({});
  const [InputFields, setInputFields] = useState([]);
  const [UserDetailInputFields, setUserDetailInputFields] = useState([]);
  const [DocumentsFields, setDocumentsFields] = useState([]);
  const [FreightFields, setFreightFields] = useState([]);
  const [createLoadReceipt, { loading: CreateLoading }] = useMutation(CREATE_FTL_CONSIGNMENT_NOTE);
  const [lockLoadReceipt, { loading: LockLoading }] = useMutation(LOCK_FTL_CONSIGNMENT_NOTE);
  const [editLoadReceipt, { loading: EditLoading }] = useMutation(EditFTLLoadReceipt);
  const [getDataById, { loading: GetLoading }] = useLazyQuery(GetFTLLoadReceiptById, {
    fetchPolicy: "no-cache",
  });
  const [getDataByIdForCopy, { loading: GetLoadingForCopy }] = useLazyQuery(GetFTLLoadReceiptByIdForCopy, {
    fetchPolicy: "no-cache",
  });

  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_Key,
      },
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        // console.log(data);
        let CNFieldData = data?.formSectionAndFields.filter((e) => e.name === "Consignment_Note_Details");
        let FreightTypeField = data?.formSectionAndFields.filter((e) => e.name === "Freight_Charges");
        let DocumentsField = data?.formSectionAndFields.filter((e) => e.name === "Documents");
        let UserFieldData = data?.formSectionAndFields.filter(
          (e) => e.name !== "Consignment_Note_Details" && e.name !== "Freight_Charges" && e.name !== "Documents"
        );
        setInputFields(CNFieldData);
        setFreightFields(FreightTypeField);
        setUserDetailInputFields(UserFieldData);
        setDocumentsFields(DocumentsField)
      },
    }
  );
  const [deleteLoadReceipt, { loading: deleteLoading }] = useMutation(Delete_FTL_LR);
  const [getDataByKey] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: Form_Key,
    },
    fetchPolicy: "network-only",
  });

  const [getUserDataById, { loading: GetUserDataLoading }] = useLazyQuery(UserDataById, {
    fetchPolicy: "no-cache",
  });
  const LoadingState = CreateLoading || EditLoading || GetLoading;


  const handleErrorsChange = (newErrors) => {
    // debugger;
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  useEffect(() => {
    getFormSectionAndFields();
  }, []);

  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit, close) => {
    const formErrorsNew = {
      0: formErrors?.Consignment_Note_Details,
      1: formErrors?.Consignor_Details,
      2: formErrors?.Consignee_Details,
      3: formErrors?.Bill_Account_Details,
    };
    const Error = checkFormErrors(formErrorsNew);
    if (!Error) {
      if (close) {
        submit("close");
      } else {
        submit("");
      }
    }
  };

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  let handleFoucs = (id) => {
    const input = document.getElementById(id);
    if (input) {
      input.focus();
    }
  };

  const HandleSettingClick = () => {
    setOpenSetting(true);
  };

  useEffect(() => {
    if (itemsData) {
      let newItemData = itemsData?.length > 0 ? itemsData.map((e) => {
        let obj = {};
        obj.No_Of_Boxes = e?.No_Of_Boxes;
        obj.Part_Name = e?.Part_Name;
        obj.Part_Number = e?.Part_Number;
        obj.Volumetric_Weight = e?.Volumetric_Weight;
        obj.Actual_Weight = e?.Actual_Weight;
        obj.Charge_Weight = e?.Charge_Weight;
        obj.Rate = e?.Rate;
        obj.Freight_Amount = e?.Freight_Amount;
        if (e?.Part_Name_Data) {
          obj.Part_Name = e?.Part_Name_Data?.Part_Name;
        }
        return obj;
      }) : [];
      setModifiedItemData(newItemData);
    }
  }, [itemsData]);

  useEffect(() => {
    if (FormData?.Freight_Type && !allFieldsData?.Bill_Consignor) {
      setFormValue({ Freight_Type: FormData?.Freight_Type });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Bill_Consignor: {},
          },
        },
      });
      updateSingleField(formRef, "Bill_Consignor", "");
    }
  }, [FormData?.Freight_Type]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.SelRows_ids || []);
  }, [fielddataRedux]);


  useEffect(() => {
    if (FormData?.Outward_Date && FormData?.Inward_Date) {
      let remainDays = getDaysDifference(FormData.Outward_Date, FormData.Inward_Date);
      updateSingleField(formRef, "Trip_Days", remainDays);
    }

    if (FormData?.Trip_Days && FormData?.Allow_Days) {
      let totalDays = FormData?.Trip_Days - FormData?.Allow_Days;
      updateSingleField(formRef, "Detaintion_Days", totalDays);
    }

    if (FormData?.Outward_Date && FormData?.Inward_Date && FormData?.Allow_Days && FormData?.Detaintion_Rate) {
      let remainDays = getDaysDifference(FormData.Outward_Date, FormData.Inward_Date);
      if (FormData?.Allow_Days < remainDays) {
        let totalDays = remainDays - FormData?.Allow_Days;

        let DetaintionAmount = totalDays * FormData?.Detaintion_Rate;

        updateSingleField(formRef, "Detaintion_Amount", DetaintionAmount);
      } else {
        ErrorToast(`Allow Days should be less then ${remainDays}`);
      }
    } else {
      updateSingleField(formRef, "Detaintion_Amount", "");
    }
  }, [FormData?.Outward_Date, FormData?.Inward_Date, FormData?.Allow_Days, FormData?.Detaintion_Rate]);

  useEffect(() => {
    if (TypeOfPortal === "Add" && FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name) {
      updateSingleField(formRef, "Driver_Number", FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name?.Mobile_Number);
    }
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name]);

  useEffect(() => {
    if (InputFields.length) {
      if (userData.userDetails[0]._id && TypeOfPortal == "Add") {
        getUserDataById({
          variables: {
            ID: userData?.userDetails[0]?._id,
          },
        }).then((res) => {
          if (res?.data?.user[0]?.LR_Center_Data?.Center_Name) {
            const inputNames = ["LR_Center"];

            inputNames.forEach((name) => {
              const input = document.getElementsByName(name);
              if (input.length > 0) {
                const lastInput = input[input.length - 1] as HTMLInputElement;
                lastInput.disabled = true;
              }
            });
            dispatch({
              type: "StoreMasterData",
              payload: {
                formkey: Form_Key,
                data: {
                  LR_Center: res?.data?.user[0]?.LR_Center_Data,
                },
              },
            });

            updateSingleField(formRef, "LR_Center", res?.data?.user?.[0]?.LR_Center_Data?.Center_Name || "");
            updateSingleField(formRef, "LR_No", res?.data?.user?.[0]?.LR_Center_Data?.lr_books?.Current_Number || "");
          } else {
            const inputNames = ["LR_Center"];

            inputNames.forEach((name) => {
              const input = document.getElementsByName(name);
              if (input.length > 0) {
                const lastInput = input[input.length - 1] as HTMLInputElement;
                lastInput.disabled = false;
              }
            });
          }
        });
      }
    }
  }, [userData?.userDetails[0]?._id, currentBranch, InputFields]);

  useEffect(() => {
    if (FormData?.LR_Center && !allFieldsData?.LR_No) {
      updateSingleField(
        formRef,
        "LR_No",
        FormDataFromRedux?.MasterData[Form_Key]?.LR_Center?.lr_books?.Current_Number || ""
      );
    } else if (!FormData?.LR_Center) {
      updateSingleField(formRef, "LR_No", "");
    }
  }, [FormData?.LR_Center]);

  useEffect(() => {
    if (FormDataFromRedux?.MasterData[Form_Key]?.LR_Center?.Editable) {
      const inputNames = ["LR_No"];

      inputNames.forEach((name) => {
        const input = document.getElementsByName(name);
        if (input.length > 0) {
          const lastInput = input[input.length - 1] as HTMLInputElement;
          lastInput.disabled = false;
        }
      });
    } else {
      const inputNames = ["LR_No"];

      inputNames.forEach((name) => {
        const input = document.getElementsByName(name);
        if (input.length > 0) {
          const lastInput = input[input.length - 1] as HTMLInputElement;
          lastInput.disabled = true;
        }
      });
    }
  }, [FormDataFromRedux?.MasterData[Form_Key]?.LR_Center]);

  useEffect(() => {
    if (FormData?.Service_Type !== "") {
      const updatedLoadFields = Loadfilds.map((section) => {
        if (section.name === "Consignment_Note_Details") {
          return {
            ...section,
            fields: section.fields.map((field) => {
              if (field.name === "Vehicle_No") {
                return {
                  ...field,
                  isRequired: FormData?.Service_Type === "FTL" ? true : false,
                };
              }
              return field;
            }),
          };
        }
        return section;
      });
      setLoadFields(updatedLoadFields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FormData?.Service_Type]);

  useEffect(() => {
    let totalBoxes = 0;
    let totalWeight = 0;
    let totalQuantity = 0;
    let totalFreightAmount = 0;
    let totalKM = 0;
    if (itemsData) {
      itemsData.forEach((materialItem: any) => {
        totalBoxes += Number(materialItem.No_Of_Boxes);
      });
      itemsData.forEach((materialItem: any) => {
        totalWeight += Number(materialItem.Charge_Weight);
      });
      itemsData.forEach((materialItem: any) => {
        totalQuantity += Number(materialItem.Total_Quantity);
      });
      itemsData.forEach((materialItem: any) => {
        totalFreightAmount += Number(materialItem.Freight_Amount);
      });

    }

    updateSingleField(formRef, "Total_Weight", totalWeight);
    updateSingleField(formRef, "Total_Article", totalBoxes);
    updateSingleField(formRef, "Total_Quantity", totalQuantity);
    // updateSingleField(formRef, "Total_KM", totalKM);
    // setTotalFreightAmount(totalFreightAmount);
  }, [itemsData]);


  const getDefaultValues = async () => {

    const { data } = await getDataByKey({
      variables: {
        Form_Key,
      },
    });

    let obj = { ...data?.User_Preferences_By_Form_Key?.configurationData };

    dispatch({
      type: "StoreMasterData",
      payload: {
        formkey: "Preference",
        data: {
          Default_Service_Type: obj?.Default_Service_Type,

          Default_Assign_Pickup: obj?.Default_Assign_Pickup,
        },
      },
    });
    obj.Default_Service_Type = obj?.Default_Service_Type?.Service_Type_Name;

    setFormdata((prev) => ({
      ...prev,
      ...obj,
    }));

    return data?.User_Preferences_By_Form_Key?.configurationData;
  };

  let updateDefaultdata = () => {
    getDefaultValues()
      .then((defaultData) => {

        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Service_Type: defaultData?.Default_Service_Type,
            },
          },
        });
        updateValueForm(formRef, {
          Date: GetTodaysDateINdmy() || "",
          FOV: 0,
          Freight_Type: defaultData?.Default_Freight_Type,
          Service_Type: defaultData?.Default_Service_Type?.Service_Type_Name,
        });
      })
      .catch((err) => {
        updateValueForm(formRef, {
          Date: GetTodaysDateINdmy() || "",
          FOV: 0,
        });
      });
  };

  useEffect(() => {
    if (InputFields.length) {
      if (TypeOfPortal === "Edit" || TypeOfPortal === "View") {
        getDataById({
          variables: {
            id: selectedRow,
          },
        }).then((res) => {
          let data = { ...res?.data?.getFTLLoadReceiptsById[0] };

          delete data?.__typeName;
          // delete data?.LR_Invoice_Data;
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Consignor: data?.Consignor_Data,
                Consignee: data?.Consignee_Data,
                Bill_Consignor: data?.Bill_Consignor_Data,
                Assign_Pickup: data.Assign_Pickup_Data,
                Consignor_Person: data.Consignor_Person_Data,
                Consignee_Person: data.Consignee_Person_Data,
                Bill_Consignor_Person: data.Bill_Consignor_Person_Data,
                LR_Center: data?.LR_Center_Data,
                Driver_Name: data?.Driver_Name_Data,
                Vehicle_No: data?.Vehicle_No_Data,
                Service_Type: data?.Service_Type_Data,
                Key_Account_Manager: data?.Key_Account_Manager_Data,
                Branch_Code: data?.Branch_Code_Data,
              },
            },
          });
          data.Service_Type = data?.Service_Type_Data?.Service_Type_Name;
          data.Assign_Pickup = data?.Assign_Pickup_Data?.Name;
          data.Consignor = data?.Consignor_Data?.Search_Value;
          data.Consignee = data?.Consignee_Data?.Search_Value;
          data.Bill_Consignor = data?.Bill_Consignor_Data?.Search_Value;
          data.Consignor_Person = data?.Consignor_Person_Data?.Name;
          data.Consignee_Person = data?.Consignee_Person_Data?.Name;
          data.Key_Account_Manager = data?.Key_Account_Manager_Data?.Full_Name;
          data.Bill_Consignor_Person = data?.Bill_Consignor_Person_Data?.Name;
          // data.material = res?.data?.getFTLLoadReceiptsById[0]?.LR_Invoice_Data;
          data.LR_Center = data?.LR_Center_Data?.Center_Name;
          data.Driver_Name = data?.Driver_Name_Data?.Name;
          data.Vehicle_No = data?.Vehicle_No_Data?.Vehicle_No;
          data.Date = IsoToDateWithoutTime(data?.Date);

          let invoiceD = data?.LR_Invoice_Data?.map((e) => ({
            ...e,
            Invoice_Date: IsoToDateWithoutTime(e?.Invoice_Date),
            Eway_Bill_Date: IsoToDateWithoutTime(e?.Eway_Bill_Date),
            Eway_Bill_Expiry_Date: IsoToDateWithoutTime(e?.Eway_Bill_Expiry_Date),
          }));

          setInvoiceData(invoiceD);
          setItemsData(data?.Invoice_Material_Data);
          setCustomerNotesdata(data?.Customer_Note);
          setNotesdata(data?.Notes);

          setMyData(data);
          setAllFieldsData(data);
          updateValueForm(formRef, data);
        });
      } else if (TypeOfPortal == "Copy") {
        getDataByIdForCopy({
          variables: {
            id: selectedRow,
          },
        }).then((res) => {
          let data = { ...res?.data?.getFTLLoadReceiptsById[0] };

          delete data?.__typeName;
          // delete data?.LR_Invoice_Data;
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Consignor: data?.Consignor_Data,
                Consignee: data?.Consignee_Data,
                Bill_Consignor: data?.Bill_Consignor_Data,
                Assign_Pickup: data.Assign_Pickup_Data,
                Consignor_Person: data.Consignor_Person_Data,
                Consignee_Person: data.Consignee_Person_Data,
                Bill_Consignor_Person: data.Bill_Consignor_Person_Data,
                Driver_Name: data?.Driver_Name_Data,
                Vehicle_No: data?.Vehicle_No_Data,
                Service_Type: data?.Service_Type_Data,
                Key_Account_Manager: data?.Key_Account_Manager_Data,
                Branch_Code: data?.Branch_Code_Data,
              },
            },
          });
          data.Service_Type = data?.Service_Type_Data?.Service_Type_Name;
          data.Assign_Pickup = data?.Assign_Pickup_Data?.Name;
          data.Consignor = data?.Consignor_Data?.Search_Value;
          data.Consignee = data?.Consignee_Data?.Search_Value;
          data.Bill_Consignor = data?.Bill_Consignor_Data?.Search_Value;
          data.Consignor_Person = data?.Consignor_Person_Data?.Name;
          data.Consignee_Person = data?.Consignee_Person_Data?.Name;
          data.Key_Account_Manager = data?.Key_Account_Manager_Data?.Full_Name;
          data.Bill_Consignor_Person = data?.Bill_Consignor_Person_Data?.Name;
          // data.material = res?.data?.getFTLLoadReceiptsById[0]?.LR_Invoice_Data;
          data.Driver_Name = data?.Driver_Name_Data?.Name;
          data.Vehicle_No = data?.Vehicle_No_Data?.Vehicle_No;
          data.Date = IsoToDateWithoutTime(data?.Date);
          setItemsData(data?.Invoice_Material_Data);

          setMyData(data);
          setAllFieldsData(data);
          updateValueForm(formRef, data);
        });
      } else if (TypeOfPortal == "Add") {
        updateDefaultdata();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TypeOfPortal, InputFields]);

  useEffect(() => {
    const value = FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code;
    if (TypeOfPortal === "Add" && value && currentBranch && currentBranch?._id !== value?._id) {
      setInvoiceData([]);
      setItemsData([]);
      ClearSpecificForm(dispatch, Form_Key);
      ClearFields(formRef);
    }
    setCurrentBranch(value);
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code]);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  let handleAddInvoiceData = (invoice, items) => {
    setInvoiceData(invoice);
    setItemsData(items);
  };

  function isValidISODate(str) {
    const date = new Date(str);
    return !isNaN(date.getTime());
  }

  const handleEdit = (i) => {
    setEditIndex((prev) => String(i));
    setMeterial(true);
  };


  const submit = async (close) => {
    let totalBoxes = 0;
    let CNmasterData = FormDataFromRedux?.MasterData?.[Form_Key];
    let obj = {
      ...FormData,
      LR_Center: CNmasterData?.LR_Center?._id,
      Service_Type: CNmasterData?.Service_Type?._id,
      Vehicle_No: CNmasterData?.Vehicle_No?._id,
      Driver_Name: CNmasterData?.Driver_Name?._id,
      Driver_Number: String(FormData.Driver_Number),
      Date: FormData?.Date ? convertToISO(FormData?.Date) : null,
      LR_No: FormData?.LR_No ? String(FormData?.LR_No) : null,
    };
    obj.LR_Book_Id = FormDataFromRedux?.MasterData[Form_Key]?.LR_Center?.lr_books?._id;
    obj["Notes"] = notesdata;
    obj["Consignor_GST_No"] = CNmasterData?.Consignor?.GST_Number ? CNmasterData?.Consignor?.GST_Number : "";
    obj["Consignee_GST_No"] = CNmasterData?.Consignee?.GST_Number ? CNmasterData?.Consignee?.GST_Number : "";
    obj["Bill_GST_No"] = CNmasterData?.Bill_Consignor?.GST_Number ? CNmasterData.Bill_Consignor.GST_Number : "";
    obj["Consignor_City"] = CNmasterData?.Consignor?.Business_City ? CNmasterData?.Consignor?.Business_City : "";
    obj["Consignee_City"] = CNmasterData?.Consignee?.Business_City ? CNmasterData?.Consignee?.Business_City : "";
    obj["Bill_City"] = CNmasterData?.Bill_Consignor?.Business_City ? CNmasterData.Bill_Consignor.Business_City : "";
    obj["Consignor_Address"] = CNmasterData?.Consignor?.Business_Address
      ? CNmasterData?.Consignor?.Business_Address
      : "";
    obj["Consignee_Address"] = CNmasterData?.Consignee?.Business_Address
      ? CNmasterData?.Consignee?.Business_Address
      : "";
    obj["Bill_Consignor_Address"] = CNmasterData?.Bill_Consignor?.Business_Address
      ? CNmasterData.Bill_Consignor.Business_Address
      : "";

    let acutalWeight = 0;
    let volumetricWeight = 0;
    let materialData = invoiceData?.map((materialItem) => {
      let newObj = { ...materialItem };

      newObj.Eway_Bill_Number = String(newObj?.Eway_Bill_Number);
      if (newObj?.Invoice_Date && !isValidISODate(newObj?.Invoice_Date)) {
        newObj.Invoice_Date = convertToISO(newObj?.Invoice_Date);
      }
      if (newObj?.Eway_Bill_Date && !isValidISODate(newObj?.Eway_Bill_Date)) {
        newObj.Eway_Bill_Date = convertToISO(newObj?.Eway_Bill_Date);
      }
      if (newObj?.Eway_Bill_Expiry_Date && !isValidISODate(newObj?.Eway_Bill_Expiry_Date)) {
        newObj.Eway_Bill_Expiry_Date = convertToISO(newObj?.Eway_Bill_Expiry_Date);
      }

      if (newObj?.__typename) {
        delete newObj.__typename;
      }
      if (TypeOfPortal !== "Edit") {
        delete newObj?._id;
      }

      return newObj;
    });

    let updateItemData = itemsData.map((item) => {
      let clonedItem = { ...item };
      if (TypeOfPortal !== "Edit") {
        delete clonedItem._id;
      }
      if (clonedItem?.__typename) {
        delete clonedItem.__typename;
      }
      if (clonedItem?.Part_Data) {
        clonedItem.Part_Data = clonedItem.Part_Data?.map((e) => {
          let partobj = { ...e };
          if (partobj?.Part_Name) {
            partobj.Part_Name = partobj?.Part_Name?._id;
          }
          delete partobj?._id
          delete partobj?.__typename;
          return partobj;
        });
      }
      if (clonedItem.Packaging_Data) {
        clonedItem.Packaging = clonedItem.Packaging_Data?._id;
      }
      delete clonedItem.Packaging_Data;
      delete clonedItem.Part_Name_Data;
      acutalWeight += Number(clonedItem.Actual_Weight);
      volumetricWeight += Number(clonedItem.Volumetric_Weight);
      totalBoxes += clonedItem.No_Of_Boxes;
      return clonedItem;
    });


    obj.Total_Volumetric_Weight = volumetricWeight;
    obj.Total_Actual_Weight = acutalWeight;
    obj["LR_Invoice_Data"] = materialData;
    obj["Invoice_Material_Data"] = updateItemData;

    obj.Consignor = CNmasterData?.Consignor?._id;
    obj.Consignee = CNmasterData?.Consignee?._id;
    obj.Bill_Consignor = CNmasterData?.Bill_Consignor?._id;
    obj.Key_Account_Manager = CNmasterData?.Key_Account_Manager?._id;
    obj.Consignor_Person = FormDataFromRedux?.MasterData[Form_Key]?.Consignor_Person?._id;
    obj.Consignee_Person = FormDataFromRedux?.MasterData[Form_Key]?.Consignee_Person?._id;
    obj.Bill_Consignor_Person = FormDataFromRedux?.MasterData[Form_Key]?.Bill_Consignor_Person?._id;
    obj.Default_Service_Type = FormDataFromRedux?.MasterData?.Preference?.Default_Service_Type?._id;
    obj.Customer_Note = customerNotesdata;
    obj.Total_Number_Of_Boxes = totalBoxes;
    delete obj.Invoice_Add;
    delete obj.Eway_Bill_Add;


    if (TypeOfPortal === "Add" || TypeOfPortal === "Copy") {
      await createLoadReceipt({
        variables: {
          FTLLoadReceiptsInput: obj,
        },
      })
        .then((res) => {
          SuccessToast("FTL Consignment Note Created Sucessfully");
          dispatch({ type: "Refetch", payload: true });
          if (close) {
            Closeformfunction();
          } else {
            setNotesdata("");
            setCustomerNotesdata("");
            ClearSpecificForm(dispatch, Form_Key);

            setInvoiceData([]);
            setItemsData([]);
            setModifiedItemData([]);
            setMyData({ material: [] });
            handleFormReset(formRef);
            updateDefaultdata();
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
    if (TypeOfPortal === "Edit") {
      await editLoadReceipt({
        variables: {
          id: selectedRow,
          LoadReceiptInput: obj,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("FTL Consignment Note Edited Sucessfully");
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
    if (TypeOfPortal == "Delete") {
      await deleteLoadReceipt({
        variables: {
          idsToDelete: selectedRows,
        },
      })
        .then((res) => {
          SuccessToast(res?.data?.deleteFTLLoadReceiptsMaster?.message);
          dispatch({ type: "Refetch", payload: true });
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }

  };

  let handleLockRecords = async () => {
    await lockLoadReceipt({
      variables: {
        idsToUpdate: selectedRows,
        Is_Lock: TypeOfPortal == "Lock" ? true : false
      },
    })
      .then((res) => {
        dispatch({ type: "Refetch", payload: true });
        SuccessToast(`Consignment Note(LR) ${TypeOfPortal} Successfully`);
        Closeformfunction();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  }

  const Closeformfunction = () => {
    setMyData({ material: [] });
    setNotesdata("");
    handleFormReset(formRef);
    setInvoiceData([]);
    setItemsData([]);
    setModifiedItemData([]);
    ClearSpecificForm(dispatch, Form_Key);
    settoggle(false);
    ParentPortalCloseFunction();
  };


  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={deleteLoading}
        />
      </Reactportal>
    );
  }

  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={handleLockRecords}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={LockLoading}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }

  return (
    <>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={modifiedTypeOfPortal}
        ShowBranchInput={true}
        Form_Key={Form_Key}
        id={allFieldsData?.Unique_Id ? allFieldsData?.Unique_Id : ""}
        TypeOfId={allFieldsData?.Unique_Id ? allFieldsData?.Unique_Id : ""}
        idTitle="Booking ID"
        AdditionalContent={() => {
          return (
            <span onClick={HandleSettingClick} className="settingIcon">
              {" "}
              <IoSettingsOutline className="settingIcon" />
            </span>
          );
        }}
      >
        {LoadingState && <div className="loader-line-div" />}
        <div className="loadReceiptmaindiv">
          {/* Section-1 */}
          <div className="horizontalcontainer">
            {InputFields &&
              InputFields.map((e) => {
                return (
                  <div key={e.id} className="">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="horizantalSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        onhandleFormikChange={HanldeChangeonForm}
                        validation_Schema={e?.Valid_schema}
                        onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                        formkey={Form_Key}
                        formRef={formRef}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
          {/* {section-2} */}
          <div className="AccountDetailsSectionBox">
            {UserDetailInputFields?.map((user) => {
              return (
                <MainUserDetails
                  inputfields={user.fields}
                  handleErrorsChange={handleErrorsChange}
                  fielddata={FormData}
                  formkey={Form_Key}
                  Type={user.name}
                  formRef={formRef}
                  TypeOfPortal={TypeOfPortal}
                  onhandleFormikChange={HanldeChangeonForm}
                  allFieldsData={allFieldsData}
                  setFirstLoad={setFirstLoad}
                />
              );
            })}
          </div>
          {/* {section-3} */}
          <div className="DataTableSection">
            <InvoiceAndItemTable
              data={invoiceData}
              Form_Key={Form_Key}
              tableName={"Invoice"}

            />
          </div>
          <div className="DataTableSection">
            <InvoiceAndItemTable data={modifiedItemData} Form_Key={Form_Key} tableName={"Item"} />
          </div>
          <div className="MeterialButton">
            <Button
              action={() => setMeterial(true)}
              text="ADD"
              name="AddMeterial"
              type={""}
              children={""}
              disabled={""}
            />
          </div>
          {Meterial ? (
            <>
              <AddInvoiceAndItemModal
                SetMeterial={() => {
                  setMeterial(false);
                  setEditIndex("");
                }}
                handleAddInvoiceData={handleAddInvoiceData}
                show={Meterial}
                config={{ AddMaterial, AddMeterialItems, AddMeterialDocsUpload }}
                Data={{ invoiceData, itemsData }}
                Form_Key={Form_Key}
                handleFoucs={handleFoucs}
              />
            </>
          ) : null}

          {/* Section-4 */}
          <div className="ReceiptNoteImageDetails">
            <div className="subNoteImage">
              <div>
                <div>
                  <p className="NoteLable1">Note</p>
                </div>
                <div className="moredetailsection1">
                  <textarea name="note" value={notesdata} onChange={(e) => setNotesdata(e.target.value)}></textarea>
                </div>
              </div>
              <div>
                <div>
                  <p className="NoteLable1">Customer Note</p>
                </div>
                <div className="moredetailsection1 customerNote">
                  <textarea
                    name="note"
                    value={customerNotesdata}
                    onChange={(e) => setCustomerNotesdata(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="subNoteImage">
              <div className="">
                {DocumentsFields?.length > 0 &&
                  DocumentsFields.map((e) => {
                    return (
                      <div key={e.id} className="">
                        <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                        <div className="horizantalSection insidecontainer">
                          <FormInputSectionComponent
                            inputfields={e.fields}
                            Type={e.name}
                            onhandleFormikChange={HanldeChangeonForm}
                            validation_Schema={e?.Valid_schema}
                            onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                            formkey={Form_Key}
                            TypeOfPortal={TypeOfPortal}
                            formRef={formRef}
                          />
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
            <div className="subNoteImage">
              <div>
                <p className="NoteLable3">Fright Charges</p>
              </div>
              <div className="Freight">
                {FreightFields.map((e: any, i) => {
                  return (
                    <LRPickupUpdationFreightChargesForm
                      inputfields={e.fields}
                      Type={e.name}
                      totalFreightAmount={totalFreightAmount}
                      // handleFreightOnChange={handleFreightOnChange}
                      TypeOfPortal={TypeOfPortal}
                      formkey={Form_Key}
                      FormData={FormData}
                      formRef={formRef}
                      onhandleFormikChange={HanldeChangeonForm}
                      handleErrorsChange={() => handleErrorsChange()}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={() => {
            Validate_handleSubmit(submit, "");
          }}
          submitType={submitType}
          SaveAndClose={() => {
            Validate_handleSubmit(submit, "close");
          }}
          handleformclose={() => {
            Closeformfunction();
          }}
          loadingState={CreateLoading || EditLoading || GetLoading ? true : false}
        />
      </Reactportal>
      {openSetting && (
        <FormConfiguration
          show={openSetting}
          ParentClosingFunction={setOpenSetting}
          config={FTLConsignmentNoteConfiguration}
          HanldeChangeonForm={HanldeChangeonForm}
          formRef={formRef}
          setFirstLoad={setFirstLoad}
          allFieldsData={allFieldsData}
          getFormSectionAndFields={getFormSectionAndFields}
          formKey={Form_Key}
          forFormValues={FormData}
          preference={true}
          ToGetDefaultValues={() => {
            if (TypeOfPortal == "Add") {
              updateDefaultdata();
            }
          }}
        />
      )}
    </>
  );
};

export default AddFTLConsignmentNote;

// const AddFTLConsignmentNote = ({ fielddata, show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
//   const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, " FTL Consignment Note");
//   const [LoadFieldsstate, setLoadFields] = useState<any>(Loadfilds);
//   const [FormData, setFormdata] = useState<any>({});
//   const [toggle, settoggle] = useState(show ? show : false);
//   const [notesdata, setNotesdata] = useState("");
//   const [myData, setMyData] = useState<any>({ material: [] });
//   const [autoLRNo, setAutoLRNo] = useState(false);
//   const [totalQuantity, setTotalQuantity] = useState(0);
//   const [sendValue, setSendValue] = useState(0);
//   const [totalFreightAmount, setTotalFreightAmount] = useState(0);
//   const { pushModal, popModal, getTopModal } = useModalContext();
//   const [customerNotesdata, setCustomerNotesdata] = useState("");
//   const [tableData, setTableData] = useState<any[]>([]);
//   const [Meterial, setMeterial] = useState(false);
//   const [editIndex, setEditIndex] = useState("");
//   const [perKM, setperKM] = useState(0);
//   const [LRcenterDisabled, setLRCenterDisabled] = useState(false);
//   const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
//   const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer.FTL_Consignment_Note);
//   const selectedRow = fielddataRedux?.Selected_Row?._id;
//   let userData = sessionStorage.getItem("userData") && JSON.parse(sessionStorage?.getItem("userData") || "");
//   const dispatch = useDispatch();
//   const formRef = useRef({});
//   const Form_Key = "FTL_Consignment_Note";

//   const [formErrors, setFormErrors] = useState<any>({});

//   const [createLoadReceipt, { loading: CreateLoading }] = useMutation(CREATE_CONSIGNMENT_NOTE);
//   const [editLoadReceipt, { loading: EditLoading }] = useMutation(EditFTLLoadReceipt);
//   const [getDataById, { loading: GetLoading }] = useLazyQuery(GetFTLLoadReceiptById, {
//     fetchPolicy: "no-cache",
//   });
//   const [getUserDataById, { loading: GetUserDataLoading }] = useLazyQuery(UserDataById, {
//     fetchPolicy: "no-cache",
//   });
//   const LoadingState = CreateLoading || EditLoading || GetLoading;
//   const handleErrorsChange = (newErrors) => {
//     // debugger;
//     setFormErrors((currentErrors) => ({
//       ...currentErrors,
//       ...newErrors,
//     }));
//   };

//   //to check errors and throw the error submit will not
//   const Validate_handleSubmit = (submit, close) => {
//     const formErrorsNew = {
//       0: formErrors?.Consignment_Note_Details,
//       1: formErrors?.Consignor_Details,
//       2: formErrors?.Consignee_Details,
//       3: formErrors?.Bill_Account_Details,
//     };
//     const Error = checkFormErrors(formErrorsNew);
//     if (!Error) {
//       if (close) {
//         submit("close");
//       } else {
//         submit("");
//       }
//     }
//   };

//   useEffect(() => {
//     if (FormData?.Outward_Date && FormData?.Inward_Date) {
//       let remainDays = getDaysDifference(FormData.Outward_Date, FormData.Inward_Date);
//       updateSingleField(formRef, "Trip_Days", remainDays);
//     }

//     if (FormData?.Outward_Date && FormData?.Inward_Date && FormData?.Allow_Days && FormData?.Detaintion_Rate) {
//       let remainDays = getDaysDifference(FormData.Outward_Date, FormData.Inward_Date);
//       if (FormData?.Allow_Days < remainDays) {
//         let totalDays = remainDays - FormData?.Allow_Days;

//         let DetaintionAmount = totalDays * FormData?.Detaintion_Rate;
//         console.log(DetaintionAmount);
//         updateSingleField(formRef, "Detaintion_Amount", DetaintionAmount);
//       } else {
//         ErrorToast(`Allow Days should be less then ${remainDays}`);
//       }
//     } else {
//       updateSingleField(formRef, "Detaintion_Amount", "");
//     }
//   }, [FormData?.Outward_Date, FormData?.Inward_Date, FormData?.Allow_Days, FormData?.Detaintion_Rate]);

//   useEffect(() => {
//     if (FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name) {
//       updateSingleField(formRef, "Driver_Number", FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name?.Mobile_Number);
//     }
//   }, [FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name]);

//   useEffect(() => {
//     if (TypeOfPortal === "Add" && userData.userDetails[0]._id) {
//       getUserDataById({
//         variables: {
//           ID: userData?.userDetails[0]?._id,
//         },
//       }).then((res) => {
//         if (res?.data?.user[0]?.LR_Center_Data) {
//           setLRCenterDisabled(true);
//         }

//         dispatch({
//           type: "StoreMasterData",
//           payload: {
//             formkey: Form_Key,
//             data: {
//               LR_Center: res?.data?.user[0]?.LR_Center_Data,
//             },
//           },
//         });
//         updateSingleField(formRef, "Date", GetTodaysDateINdmy() || "");
//         updateSingleField(formRef, "LR_Center", res?.data?.user?.[0]?.LR_Center_Data?.Center_Name || "");
//         updateSingleField(formRef, "LR_No", res?.data?.user?.[0]?.LR_Center_Data?.lr_books?.Current_Number || "");
//       });
//     }
//   }, [userData?.userDetails[0]?._id]);

//   useEffect(() => {
//     if (myData?.material?.length > 0) {
//       let newArr = myData?.material?.map((obj) => {
//         let newObj = { ...obj };
//         newObj.Invoice_Date = newObj.Invoice_Date ? IsoToDateWithoutTime(newObj.Invoice_Date) : "";
//         newObj.Eway_Bill_Date = newObj.Eway_Bill_Date ? IsoToDateWithoutTime(newObj.Eway_Bill_Date) : "";
//         newObj.Eway_Bill_Expiry_Date = newObj.Eway_Bill_Expiry_Date
//           ? IsoToDateWithoutTime(newObj.Eway_Bill_Expiry_Date)
//           : "";
//         delete newObj.Invoice_Material_Data;
//         delete newObj.Eway_Bill_Add;
//         delete newObj.Invoice_Add;
//         if (newObj?.__typename) {
//           delete newObj?.__typename;
//           delete newObj?.Total_Freight_Amount;
//         }
//         return newObj;
//       });
//       setTableData(newArr);
//     } else {
//       setTableData([]);
//     }
//   }, [myData?.material]);

//   useEffect(() => {
//     if (FormData?.Service_Type !== "") {
//       const updatedLoadFields = Loadfilds.map((section) => {
//         if (section.name === "Consignment_Note_Details") {
//           return {
//             ...section,
//             fields: section.fields.map((field) => {
//               if (field.name === "Vehicle_No") {
//                 return {
//                   ...field,
//                   isRequired: FormData?.Service_Type === "FTL" ? true : false,
//                 };
//               }
//               return field;
//             }),
//           };
//         }
//         return section;
//       });
//       setLoadFields(updatedLoadFields);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [FormData?.Service_Type]);

//   useEffect(() => {
//     let totalBoxes = 0;
//     let totalWeight = 0;
//     let totalQuantity = 0;
//     let totalFreightAmount = 0;
//     if (myData?.material) {
//       myData.material.forEach((materialItem: any) => {
//         totalBoxes += Number(materialItem.Total_Boxes);
//       });
//       myData.material.forEach((materialItem: any) => {
//         totalWeight += Number(materialItem.Total_Item_Wgt);
//       });
//       myData.material.forEach((materialItem: any) => {
//         totalQuantity += Number(materialItem.Total_Quantity);
//       });
//       myData.material.forEach((materialItem: any) => {
//         totalFreightAmount += Number(materialItem.Total_Freight_Amount);
//       });
//     }
//     console.log(totalWeight);
//     updateSingleField(formRef, "Total_Weight", totalWeight);
//     updateSingleField(formRef, "Total_Article", totalBoxes);
//     updateSingleField(formRef, "Total_Quantity", totalQuantity);
//     // setTotalFreightAmount(totalFreightAmount);
//   }, [myData?.material]);

//   useEffect(() => {
//     if (toggle) {
//       pushModal(Form_Key);
//     }
//   }, [toggle, Form_Key, pushModal]);

//   useEffect(() => {
//     const input = document.getElementsByName("Date");
//     if (input.length > 0 && !TypeOfPortal?.includes("View")) {
//       input[input.length - 1].focus();
//     }
//   }, []);

//   useEffect(() => {
//     if (TypeOfPortal === "Edit" || TypeOfPortal === "View") {
//       getDataById({
//         variables: {
//           id: selectedRow,
//         },
//       }).then((res) => {
//         let data = { ...res?.data?.getFTLLoadReceiptsById[0] };

//         delete data?.__typeName;
//         delete data?.LR_Invoice_Data;
//         dispatch({
//           type: "StoreMasterData",
//           payload: {
//             formkey: Form_Key,
//             data: {
//               Consignor: data?.Consignor_Data,
//               Consignee: data?.Consignee_Data,
//               Bill_Consignor: data?.Bill_Consignor_Data,
//               Assign_Pickup: data.Assign_Pickup_Data,
//               Consignor_Person: data.Consignor_Person_Data,
//               Consignee_Person: data.Consignee_Person_Data,
//               Bill_Consignor_Person: data.Bill_Consignor_Person_Data,
//               LR_Center: data?.LR_Center_Data,
//               Driver_Name: data?.Driver_Name_Data,
//               Vehicle_No: data?.Vehicle_No_Data,
//               Branch_Code: data?.Branch_Code_Data,
//             },
//           },
//         });
//         data.Service_Type = data?.Service_Type_Data?.Service_Type_Name;
//         data.Assign_Pickup = data?.Assign_Pickup_Data?.Name;
//         data.Consignor = data?.Consignor_Data?.Search_Value;
//         data.Consignee = data?.Consignee_Data?.Search_Value;
//         data.Bill_Consignor = data?.Bill_Consignor_Data?.Search_Value;
//         data.Consignor_Person = data?.Consignor_Person_Data?.Name;
//         data.Consignee_Person = data?.Consignee_Person_Data?.Name;
//         data.Bill_Consignor_Person = data?.Bill_Consignor_Person_Data?.Name;
//         data.material = res?.data?.getFTLLoadReceiptsById[0]?.LR_Invoice_Data;
//         data.LR_Center = data?.LR_Center_Data?.Center_Name;
//         data.Driver_Name = data?.Driver_Name_Data?.Name;
//         data.Vehicle_No = data?.Vehicle_No_Data?.Vehicle_No;
//         data.Date = IsoToDateWithoutTime(data?.Date);
//         if (data.Freight_On === "Per Box") {
//           setSendValue(data?.Total_Number_Of_Boxes);
//         } else if (data.Freight_On === "Quantity") {
//           setSendValue(data?.Total_Quantity);
//         } else if (data.Freight_On === "Per KM") {
//           setSendValue(data?.Total_KM);
//           setperKM(data?.Total_KM);
//         }
//         setCustomerNotesdata(data?.Customer_Note);
//         setNotesdata(data?.Notes);
//         console.log(data);
//         setMyData(data);
//         // setAllFieldsData(data);
//         updateValueForm(formRef, data);
//       });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [TypeOfPortal]);

//   const handleDeleteMaterial = (index) => {
//     setMyData((prevState) => {
//       const newMaterial = [...prevState.material];

//       newMaterial.splice(index, 1);
//       return { ...prevState, material: newMaterial };
//     });
//   };

//   useEffect(() => {
//     if (FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code && TypeOfPortal === "Add") {
//       setMyData((prev: any) => {
//         return {
//           ...prev,
//           material: [],
//         };
//       });
//       setTableData([]);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code]);

//   // useEffect(() => {
//   //   if (FormDataFromRedux?.MasterData[Form_Key]?.LR_Center) {

//   //     setAutoLRNo(!FormDataFromRedux?.MasterData[Form_Key]?.LR_Center?.Editable);
//   //   }
//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [FormDataFromRedux?.MasterData[Form_Key]]);

//   const HanldeChangeonForm = (values) => {
//     setFormdata((prev) => ({
//       ...prev,
//       ...values,
//     }));
//   };
//   const replaceObjectAtIndex = (newObj, idx) => {
//     const newArr = myData.material.map((item, index) => {
//       if (index === idx) {
//         return newObj;
//       }
//       return item;
//     });

//     setMyData((prevState: any) => {
//       return { ...prevState, material: newArr };
//     });
//   };

//   function isValidISODate(str) {
//     const date = new Date(str);
//     return !isNaN(date.getTime());
//   }

//   const handleEdit = (i) => {
//     setEditIndex((prev) => String(i));
//     setMeterial(true);
//   };

//   // Function to handle keyboard events
//   const handleKeyDown = (event) => {
//     if (getTopModal() === Form_Key) {
//       if (event.key === "Escape") {
//         Closeformfunction();
//       } else if (event.key === "F4" && !TypeOfPortal?.includes("View")) {
//         Validate_handleSubmit(submit);
//       }
//     }
//   };

//   // Use the useEventListener hook from usehooks-ts to listen for keydown events
//   useEventListener("keydown", handleKeyDown);

//   const submit = (close) => {
//     let totalBoxes = 0;
//     let obj = {
//       ...FormData,
//       LR_Center: FormDataFromRedux?.MasterData?.[Form_Key]?.LR_Center?._id,
//       Service_Type: FormData?.Service_Type === "Normal" ? "66ec062727b41cfc672cad5d" : "66ec064927b41cfc672cada4",
//       Vehicle_No: FormDataFromRedux?.MasterData?.[Form_Key]?.Vehicle_No?._id,
//       Driver_Name: FormDataFromRedux?.MasterData?.[Form_Key]?.Driver_Name?._id,
//       Driver_Number: String(FormData.Driver_Number),
//       Assign_Pickup: FormDataFromRedux?.MasterData?.[Form_Key]?.Assign_Pickup?._id,
//       Date: FormData?.Date ? convertToISO(FormData?.Date) : null,
//       LR_No: FormData?.LR_No ? String(FormData?.LR_No) : null,
//     };
//     obj.LR_Book_Id = FormDataFromRedux?.MasterData[Form_Key]?.LR_Center?.lr_books?._id;
//     obj["Notes"] = notesdata;
//     obj["Consignor_GST_No"] = FormDataFromRedux?.MasterData[Form_Key]?.Consignor?.AccountData?.GST_Number
//       ? FormDataFromRedux.MasterData[Form_Key].Consignor.AccountData.GST_Number
//       : FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?.GST_Number
//       ? FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?.GST_Number
//       : "";
//     obj["Consignee_GST_No"] = FormDataFromRedux?.MasterData[Form_Key]?.Consignee?.AccountData?.GST_Number
//       ? FormDataFromRedux.MasterData[Form_Key].Consignee.AccountData.GST_Number
//       : FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?.GST_Number
//       ? FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?.GST_Number
//       : "";
//     obj["Bill_GST_No"] = FormDataFromRedux?.MasterData[Form_Key]?.Bill_Consignor?.GST_Number
//       ? FormDataFromRedux.MasterData[Form_Key].Bill_Consignor.GST_Number
//       : "";
//     obj["Consignor_City"] = FormDataFromRedux?.MasterData[Form_Key]?.Consignor?.AccountData?.Business_City
//       ? FormDataFromRedux.MasterData[Form_Key].Consignor.AccountData.Business_City
//       : FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?.City
//       ? FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?.City
//       : "";
//     obj["Consignee_City"] = FormDataFromRedux?.MasterData[Form_Key]?.Consignee?.AccountData?.Business_City
//       ? FormDataFromRedux.MasterData[Form_Key].Consignee.AccountData.Business_City
//       : FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?.City
//       ? FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?.City
//       : "";
//     obj["Bill_City"] = FormDataFromRedux?.MasterData[Form_Key]?.Bill_Consignor?.Business_City
//       ? FormDataFromRedux.MasterData[Form_Key].Bill_Consignor.Business_City
//       : "";
//     obj["Consignor_Address"] = FormDataFromRedux?.MasterData[Form_Key]?.Consignor?.AccountData?.Business_Address
//       ? FormDataFromRedux.MasterData[Form_Key].Consignor.AccountData.Business_Address
//       : FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?.Address_Line_1
//       ? FormDataFromRedux?.MasterData?.[Form_Key]?.Consignor?.Address_Line_1
//       : "";
//     obj["Consignee_Address"] = FormDataFromRedux?.MasterData[Form_Key]?.Consignee?.AccountData?.Business_Address
//       ? FormDataFromRedux.MasterData[Form_Key].Consignee.AccountData.Business_Address
//       : FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?.Address_Line_1
//       ? FormDataFromRedux?.MasterData?.[Form_Key]?.Consignee?.Address_Line_1
//       : "";
//     obj["Bill_Consignor_Address"] = FormDataFromRedux?.MasterData[Form_Key]?.Bill_Consignor?.Business_Address
//       ? FormDataFromRedux.MasterData[Form_Key].Bill_Consignor.Business_Address
//       : "";

//     let acutalWeight = 0;
//     let volumetricWeight = 0;
//     let materialData = myData.material.map((materialItem) => {
//       let newObj = { ...materialItem };

//       newObj.Eway_Bill_Number = String(newObj?.Eway_Bill_Number);
//       if (newObj?.Invoice_Date && !isValidISODate(newObj?.Invoice_Date)) {
//         newObj.Invoice_Date = convertToISO(newObj?.Invoice_Date);
//       }
//       if (newObj?.Eway_Bill_Date && !isValidISODate(newObj?.Eway_Bill_Date)) {
//         newObj.Eway_Bill_Date = convertToISO(newObj?.Eway_Bill_Date);
//       }
//       if (newObj?.Eway_Bill_Expiry_Date && !isValidISODate(newObj?.Eway_Bill_Expiry_Date)) {
//         newObj.Eway_Bill_Expiry_Date = convertToISO(newObj?.Eway_Bill_Expiry_Date);
//       }

//       if (newObj?.__typename) {
//         delete newObj.__typename;
//       }
//       if (TypeOfPortal !== "Edit") {
//         delete newObj?._id;
//       }

//       newObj.Invoice_Material_Data = newObj.Invoice_Material_Data.map((item) => {
//         let clonedItem = { ...item };
//         if (TypeOfPortal !== "Edit") {
//           delete clonedItem._id;
//         }
//         if (clonedItem?.__typename) {
//           delete clonedItem.__typename;
//         }
//         console.log(clonedItem);
//         acutalWeight += Number(clonedItem.Actual_Weight);
//         volumetricWeight += Number(clonedItem.Volumetric_Weight);
//         totalBoxes += clonedItem.No_Of_Boxes;
//         return clonedItem;
//       });

//       return newObj;
//     });
//     console.log(acutalWeight);
//     obj.Total_Volumetric_Weight = volumetricWeight;
//     obj.Total_Actual_Weight = acutalWeight;
//     obj["LR_Invoice_Data"] = materialData;

//     obj.Consignor =
//       FormDataFromRedux?.MasterData[Form_Key]?.Consignor?.Account_Type_Id ||
//       FormDataFromRedux?.MasterData[Form_Key]?.Consignor?._id;
//     obj.Consignee =
//       FormDataFromRedux?.MasterData[Form_Key]?.Consignee?.Account_Type_Id ||
//       FormDataFromRedux?.MasterData[Form_Key]?.Consignee?._id;
//     obj.Bill_Consignor = FormDataFromRedux?.MasterData[Form_Key]?.Bill_Consignor?._id;
//     obj.Consignor_Person = FormDataFromRedux?.MasterData[Form_Key]?.Consignor_Person?._id;
//     obj.Consignee_Person = FormDataFromRedux?.MasterData[Form_Key]?.Consignee_Person?._id;
//     obj.Bill_Consignor_Person = FormDataFromRedux?.MasterData[Form_Key]?.Bill_Consignor_Person?._id;
//     obj.Customer_Note = customerNotesdata;
//     obj.Total_Number_Of_Boxes = totalBoxes;
//     delete obj.Invoice_Add;
//     delete obj.Eway_Bill_Add;

//     if (obj.LR_Invoice_Data.length === 0) {
//       ErrorToast("Please add at least one material");
//     } else {
//       if (TypeOfPortal === "Add") {
//         createLoadReceipt({
//           variables: {
//             FTLLoadReceiptsInput: obj,
//           },
//         })
//           .then((res) => {
//             SuccessToast("FTL Consignment Note Created Sucessfully");
//             dispatch({ type: "Refetch", payload: true });
//             if (close) {
//               Closeformfunction();
//             } else {
//               setNotesdata("");
//               setCustomerNotesdata("");
//               ClearSpecificForm(dispatch, Form_Key);
//               setSendValue(0);
//               setMyData({ material: [] });
//               handleFormReset(formRef);
//             }
//           })
//           .catch((err) => {
//             ErrorToast(err.message);
//           });
//       }
//       if (TypeOfPortal === "Edit") {
//         editLoadReceipt({
//           variables: {
//             id: selectedRow,
//             LoadReceiptInput: obj,
//           },
//         })
//           .then((res) => {
//             dispatch({ type: "Refetch", payload: true });
//             SuccessToast("FTL Consignment Note Edited Sucessfully");
//             Closeformfunction();
//           })
//           .catch((err) => {
//             ErrorToast(err.message);
//           });
//       }
//     }
//   };

//   let handleFreightOnChange = (type: string) => {
//     // if (type === "Per Box") {
//     //   setSendValue(totalArticle);
//     // } else if (type === "Quantity") {
//     //   setSendValue(totalQuantity);
//     // } else if (type == "Per KM") {
//     //   if (FormDataFromRedux[Form_Key]?.Freight_Charges?.Total_KM) {
//     //     setSendValue(FormDataFromRedux[Form_Key]?.Freight_Charges?.Total_KM);
//     //   } else {
//     //     setSendValue(perKM);
//     //   }
//     // }
//   };

//   const Closeformfunction = () => {
//     setMyData({ material: [] });
//     setNotesdata("");
//     handleFormReset(formRef);
//     ClearSpecificForm(dispatch, Form_Key);
//     popModal(Form_Key);
//     settoggle(false);
//     ParentPortalCloseFunction();
//   };
//   return (
//     <>
//       <Reactportal
//         open={toggle}
//         onClose={Closeformfunction}
//         TypeOfPortal={modifiedTypeOfPortal}
//         ShowBranchInput={true}
//         Form_Key={Form_Key}
//         // id={allFieldsData?.Unique_Id ? allFieldsData?.Unique_Id : ""}
//         // TypeOfId={allFieldsData?.Unique_Id ? allFieldsData?.Unique_Id : ""}
//         idTitle="Booking ID"
//       >
//         {LoadingState && <div className="loader-line-div" />}
//         <div className="loadReceiptmaindiv">
//           {/* Section-1 */}
//           <div className="horizontalcontainer">
//             {LoadFieldsstate &&
//               LoadFieldsstate.map((e) => {
//                 return (
//                   <div key={e.id} className="">
//                     <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
//                     <div className="horizantalSection insidecontainer">
//                       <FormInputSectionComponent
//                         inputfields={e.fields}
//                         Type={e.name}
//                         onhandleFormikChange={HanldeChangeonForm}
//                         validation_Schema={e?.Valid_schema}
//                         onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
//                         formkey={Form_Key}
//                         formRef={formRef}
//                       />
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>
//           {/* {section-2} */}
//           <div className="AccountDetailsSectionBox">
//             {UserDetails?.map((user) => {
//               return (
//                 <MainUserDetails
//                   inputfields={user.fields}
//                   handleErrorsChange={handleErrorsChange}
//                   fielddata={FormData}
//                   formkey={Form_Key}
//                   Type={user.name}
//                   formRef={formRef}
//                   onhandleFormikChange={HanldeChangeonForm}
//                 />
//               );
//             })}
//           </div>
//           {/* {section-3} */}
//           <div className="DataTableSection">
//             <InvoiceAndItemTable
//               data={tableData}
//               handleDeleteMaterial={(i) => handleDeleteMaterial(i)}
//               handleEditMaterial={(i) => handleEdit(i)}
//             />
//           </div>
//           <div className="MeterialButton">
//             <Button
//               action={() => setMeterial(true)}
//               text="Add Material"
//               name="AddMeterial"
//               type={""}
//               children={""}
//               disabled={""}
//             />
//           </div>
//           {Meterial ? (
//             <>
//               <AddMeterialSection
//                 SetMeterial={() => {
//                   setMeterial(false);
//                   setEditIndex("");
//                 }}
//                 show={Meterial}
//                 setMyData={(singleData: any, val: any, index: any) => {
//                   if (index === 0 || index) {
//                     replaceObjectAtIndex({ ...singleData, Invoice_Material_Data: val }, Number(index));
//                   } else {
//                     setMyData((prev: any) => {
//                       return {
//                         ...prev,
//                         material: [...prev.material, { ...singleData, Invoice_Material_Data: val }],
//                       };
//                     });
//                   }
//                 }}
//                 TypeOfPortal={"AddMaterial"}
//                 config={{ AddMaterial, AddMeterialItems, AddMeterialDocsUpload }}
//                 index={editIndex ? editIndex : ""}
//                 Data={editIndex ? myData?.material?.[editIndex] : {}}
//                 fielddata={editIndex ? tableData[editIndex] : undefined}
//               />
//             </>
//           ) : null}
//           {/* Section-4 */}
//           <div className="ReceiptNoteImageDetails">
//             <div className="subNoteImage">
//               <div>
//                 <div>
//                   <p className="NoteLable1">Note</p>
//                 </div>
//                 <div className="moredetailsection1">
//                   <textarea name="note" value={notesdata} onChange={(e) => setNotesdata(e.target.value)}></textarea>
//                 </div>
//               </div>
//               <div>
//                 <div>
//                   <p className="NoteLable1">Customer Note</p>
//                 </div>
//                 <div className="moredetailsection1 customerNote">
//                   <textarea
//                     name="note"
//                     value={customerNotesdata}
//                     onChange={(e) => setCustomerNotesdata(e.target.value)}
//                   ></textarea>
//                 </div>
//               </div>
//             </div>
//             <div className="subNoteImage">
//               <div>
//                 <p className="NoteLable2">Documents</p>
//               </div>
//               <div className="loadImages1">
//                 <DocumentuploadSection
//                   data={DocUpload}
//                   TypeOfPortal={modifiedTypeOfPortal}
//                   LoadForm={true}
//                   formkey={Form_Key}
//                   values={FormData}
//                   formReference={formRef}
//                 />
//               </div>
//             </div>
//             <div className="subNoteImage">
//               <div>
//                 <p className="NoteLable3">Fright Charges</p>
//               </div>
//               <div className="Freight">
//                 {FreightCharges.map((e: any, i) => {
//                   return (
//                     <LRPickupUpdationFreightChargesForm
//                       inputfields={e.fields}
//                       Type={e.name}
//                       totalFreightAmount={totalFreightAmount}
//                       handleFreightOnChange={handleFreightOnChange}
//                       TypeOfPortal={TypeOfPortal}
//                       formkey={Form_Key}
//                       FormData={FormData}
//                       formRef={formRef}
//                       onhandleFormikChange={HanldeChangeonForm}
//                     />
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         </div>
//         <PortalFooter
//           renderContent={() => <></>}
//           disabled={false}
//           submitform={() => {
//             Validate_handleSubmit(submit, "");
//           }}
//           submitType={submitType}
//           SaveAndClose={() => {
//             Validate_handleSubmit(submit, "close");
//           }}
//           handleformclose={() => {
//             Closeformfunction();
//           }}
//           loadingState={CreateLoading || EditLoading || GetLoading ? true : false}
//         />
//       </Reactportal>
//     </>
//   );
// };
